/** Utilidades do chat (F4): horários, iniciais/cores de avatar, cache dos anexos. */
import { anexos } from '../../nucleo/cliente'

// datetime('now') do SQLite é UTC sem "Z": converte para o horário local
export const dataLocal = (s: string) => new Date(`${s.replace(' ', 'T')}Z`)

export function hora(s: string): string {
  return dataLocal(s).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
}

export function dia(s: string): string {
  const d = dataLocal(s)
  const hoje = new Date()
  const ontem = new Date(Date.now() - 86_400_000)
  if (d.toDateString() === hoje.toDateString()) return 'Hoje'
  if (d.toDateString() === ontem.toDateString()) return 'Ontem'
  return d.toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long' })
}

export function quando(s: string): string {
  const d = dataLocal(s)
  return d.toDateString() === new Date().toDateString() ? hora(s) : d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })
}

export const iniciais = (nome: string) =>
  nome
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join('') || '?'

const CORES = ['#E1592A', '#2E86AB', '#3DBE6A', '#A855F7', '#F59E0B', '#14B8A6', '#EC4899', '#6366F1']
export const corDe = (id: number) => CORES[Math.abs(id) % CORES.length]

export const tamanho = (b: number) => (b < 1024 ? `${b} B` : b < 1024 ** 2 ? `${(b / 1024).toFixed(0)} KB` : `${(b / 1024 ** 2).toFixed(1)} MB`)

/** URL local (blob:) de um anexo, baixado uma vez por sessão (e guardado no cache do computador). */
const urls = new Map<string, Promise<string>>()
export function urlDoAnexo(chave: string): Promise<string> {
  let p = urls.get(chave)
  if (!p) {
    p = anexos.baixar(chave).then((r) => URL.createObjectURL(new Blob([r.bytes], { type: r.mime })))
    p.catch(() => urls.delete(chave))
    urls.set(chave, p)
  }
  return p
}

export const EMOJIS = ['👍', '✅', '👀', '🎉', '❤️', '😂', '🙏', '⚠️']

/** Texto de mensagem para prévia/aviso: link de documento vira só o título. */
export const textoSimples = (t: string) => t.replace(/\[\[doc:[A-Za-z0-9_-]{8,64}\|([^\]\n]{1,200})\]\]/g, '$1')
